<template>
	<div class="forget">
		<infoHeader :title="title" icon="el-icon-lock"></infoHeader>
		<div class="fixation">
			<div class="register-form">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="120px">
					<div class="welcome">
						找回密码
					</div>
					<el-form-item label="用户名" prop="account">
						<el-input type="text" v-model.trim="ruleForm.account" placeholder="仅英文字母，最长 14 位，区分大小写"
							maxlength="14" show-word-limit autocomplete="username"></el-input>
					</el-form-item>
					<el-form-item label="验证方式" prop="type">
						<el-select v-model="ruleForm.type" placeholder="请选择验证方式">
							<el-option v-for="(item,index) in typeList" :key="index" :value="item.value"
								:label="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号" prop="phone" v-if="ruleForm.type==1" :rules="[{required: ruleForm.type == 1,
							trigger: 'blur',validator: verify_phone}]">
						<el-input type="text" v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item label="电子邮箱" prop="email" v-if="ruleForm.type==2" :rules="[{required: ruleForm.type == 2,
							trigger: 'blur',validator: verify_email}]">
						<el-input type="text" v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="password">
						<el-input type="password" v-model.trim="ruleForm.password" placeholder="8–32 位；字母/数字/符号(!@#$%^&*)至少两类"
							maxlength="32" show-password autocomplete="new-password"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="rptpassword">
						<el-input type="password" v-model.trim="ruleForm.rptpassword" placeholder="请再次输入新密码"
							maxlength="32" show-password autocomplete="new-password"></el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="code">
						<el-input type="text" v-model="ruleForm.code" placeholder="请输入验证码">
							<el-button slot="append" :disabled="disabled" :loading="loading" @click="sendCode">
								<span v-if="!disabled">发送{{ruleForm.type==1?'短信':'邮箱'}}验证码</span>
								<span v-else>{{second}}秒后可重发</span>
							</el-button>
						</el-input>
					</el-form-item>
					<el-form-item>
						<div class="dialog-button">
							<el-button type="danger" plain @click="resetForm('ruleForm')">重置</el-button>
							<el-button type="danger" @click="submitForm('ruleForm')">修改密码</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog :visible="successDialog" :show-close="false" top="280px" width="600px">
			<div class="login-dialog-title">
				<i class="el-icon-circle-check"></i>密码修改成功
			</div>
			<div class="button">
				<el-button @click="closeSuccess, goIndex()" plain type="danger" round>返回首页</el-button>
				<el-button @click="doLogin" type="danger" round>重新登录</el-button>
			</div>
		</el-dialog>
		<pubfooter></pubfooter>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'forget',
		data() {
			let verify_account = (rule, value, callback) => {
				if (!value) {
					callback()
					return
				}
				const msg = this.$ver.getRegisterUsernameError(value)
				if (msg) callback(new Error(msg))
				else callback()
			}
			let verify_password = (rule, value, callback) => {
				if (!value) {
					callback()
					return
				}
				const msg = this.$ver.getRegisterPasswordError(value)
				if (msg) callback(new Error(msg))
				else callback()
			}
			let verify_rptpassword = (rule, value, callback) => {
				if (!value) {
					callback()
					return
				}
				const msg = this.$ver.getRegisterPasswordError(value)
				if (msg) {
					callback(new Error(msg))
					return
				}
				if (this.ruleForm.password !== value) {
					callback(new Error('两次输入的密码不一致'))
					return
				}
				callback()
			}
			let verify_phone = (rule, value, callback) => {
				if (!this.$ver.verify_phone(this.ruleForm.phone)) {
					callback(new Error('手机号格式错误'))
				} else {
					callback()
				}
			}
			let verify_email = (rule, value, callback) => {
				if (!this.$ver.verify_email(this.ruleForm.email)) {
					callback(new Error('邮箱格式错误'))
				} else {
					callback()
				}
			}
			return {
				title: '忘记密码',
				typeList: [{
						value: 1,
						label: '手机号码验证'
					},
					{
						value: 2,
						label: '邮箱验证'
					}
				],
				ruleForm: {
					account: '',
					type: 1,
					phone: '',
					email: '',
					password: '',
					rptpassword: '',
					code: ''
				},
				rule: {
					account: [{
						required: true,
						trigger: ['blur', 'change'],
						message: '请输入用户名'
					}, {
						validator: verify_account,
						trigger: ['blur', 'change']
					}],
					type: [{
						required: true,
						trigger: 'change',
						message: '请选择验证方式'
					}],
					password: [{
						required: true,
						trigger: ['blur', 'change'],
						message: '请输入新密码'
					}, {
						validator: verify_password,
						trigger: ['blur', 'change']
					}],
					rptpassword: [{
						required: true,
						trigger: ['blur', 'change'],
						message: '请确认新密码'
					}, {
						validator: verify_rptpassword,
						trigger: ['blur', 'change']
					}],
					code: [{
						required: true,
						trigger: 'blur',
						message: '请输入验证码'
					}]
				},
				verify_phone: verify_phone,
				verify_email: verify_email,
				disabled: false,
				successDialog: false,
				loading: false,
				second: 60
			};
		},
		watch: {
			'ruleForm.password'() {
				if (this.ruleForm.rptpassword && this.$refs.ruleForm) {
					this.$refs.ruleForm.validateField('rptpassword')
				}
			}
		},
		methods: {
			...mapMutations(['login', 'saveUserinfo']),
			sendCode() {
				if (this.disabled) return
				const username = (this.ruleForm.account || '').trim()
				const nameErr = this.$ver.getRegisterUsernameError(username)
				if (nameErr) {
					this.$message({ message: nameErr, type: 'error', duration: 3000 })
					return
				}
				if (this.ruleForm.type == 1) {
					if (!this.ruleForm.phone) {
						this.$message({ message: '请输入手机号', type: 'error', duration: 2000 })
						return
					}
					if (!this.$ver.verify_phone(this.ruleForm.phone)) {
						this.$message({ message: '手机号格式错误', type: 'error', duration: 2000 })
						return
					}
					let data = {
						userId: '',
						phone: this.ruleForm.phone,
						username,
						scence: 2
					}
					this.loading = true
					this.$api.frontSendMsg(data, res => {
						this.loading = false
						if (res.code == 200) {
							this.$message({
								message: '短信验证码发送成功。',
								type: 'success',
								duration: 2000
							})
							this.timer()
						}
					})
				} else {
					if (!this.ruleForm.email) {
						this.$message({ message: '请输入邮箱地址', type: 'error', duration: 2000 })
						return
					}
					if (!this.$ver.verify_email(this.ruleForm.email)) {
						this.$message({ message: '邮箱格式错误', type: 'error', duration: 2000 })
						return
					}
					this.loading = true
					this.$api.frontSendEmail({
						email: this.ruleForm.email,
						scence: 2,
						userId: '',
						username
					}, res => {
						this.loading = false
						if (res.code == 200) {
							this.$message({
								message: '邮箱验证码发送成功。',
								type: 'success',
								duration: 2000
							})
							this.timer()
						}
					})
				}
			},
			timer() {
				this.disabled = true
				this.$pub.timer(this.second, res => {
					this.second = res
					if (res == 0) {
						this.second = 60
						this.disabled = false
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields()
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const username = (this.ruleForm.account || '').trim()
						let data = {
							pwd: this.ruleForm.password,
							rePassword: this.ruleForm.rptpassword,
							phone: this.ruleForm.phone,
							code: this.ruleForm.code,
							codeType: this.ruleForm.type,
							userId: '',
							username
						}
						if (this.ruleForm.type == 1) {
							data['phone'] = this.ruleForm.phone
						} else {
							data['email'] = this.ruleForm.email
						}
						this.$api.forgetPassword(data, res => {
							this.loading = false
							if (res.code == 200) {
								this.successDialog = true
								this.active = 2
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeSuccess() {
				this.successDialog = false
			},
			doLogin() {
				this.closeSuccess()
				this.$api.frontLogin({
					username: (this.ruleForm.account || '').trim(),
					pwd: this.ruleForm.password
				}, res => {
					if (res.code == 200) {
						this.saveUserinfo(res.data.systemUser)
						this.login(res.data.token)
						let t = res.data.systemUser.authentication == 0 ? 1 : 3
						this.goIndex(t)
					}
				})
			},
			goIndex() {
				this.$router.push({
					path: '/'
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.fixation {
		display: flex;
		justify-content: center;
		padding: @vue-spacing-col-lg*2 0px;
	}

	.register-form {
		.el-select {
			width: 100%;
		}
	}

	.login-dialog-title {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		font-size: @vue-font-size-lg;
		color: @vue-text-color-red;

		i {
			margin-top: @vue-spacing-col-sm;
			margin-right: @vue-spacing-row-sm;
		}
	}

	.button {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: @vue-spacing-col-lg;
	}
</style>
